import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/call-booked";
import { buildNoindexHead } from "@/lib/noindex-seo";

export const Route = createFileRoute("/call-booked")({
  head: () => buildNoindexHead("Your Call Is Booked", "/call-booked"),
  component: Page,
});
